// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdArrowBack } from 'react-icons/lib/md';
import { Field, reduxForm } from 'redux-form';
import i18n from 'i18n-js';

import * as selectors from '../../reducers';
import * as notificationsActions from '../../actions/notifications';
import PopupHeader from '../PopupHeader';
import PopupHeaderLeftGroup from '../PopupHeaderLeftGroup';
import PopupContent from '../PopupContent';
import PopupFooter from '../PopupFooter';
import PopupHeaderTitle from '../PopupHeaderTitle';
import Button from '../Button';
import PopupCloseButton from '../PopupCloseButton';
import { RenderTextarea, RenderInput, RenderToggleSwitch } from '../FieldRenderer';
import NotificationAddressees from './NotificationAddressees';

import styles from './notificationPopoverDummy.css';
import { Cancel, Boolean } from '../CommonTexts';


type NotificationPopoverDummyPropTypes = {
  changeScreen: Function,
  handleSubmit: Function,
  isLoading?: boolean,
};

const NotificationPopoverDummy = ({
  changeScreen,
  handleSubmit,
  isLoading = false,
}: NotificationPopoverDummyPropTypes) => (
  <form onSubmit={handleSubmit}>
    <PopupHeader size="small" isBorderless>
      <PopupHeaderLeftGroup padding="verticalCenter">
        <Button
          size="medium"
          Icon={MdArrowBack}
          iconPosition="left"
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
          onClick={() => changeScreen(1)}
        />
        <PopupHeaderTitle
          title={i18n.t('buttons.send')}
          size="big"
        />

      </PopupHeaderLeftGroup>
    </PopupHeader>
    <PopupContent className={styles.content} isBorderless>
      <NotificationAddressees title={i18n.t('notifications.for')} />
      <Field
        className={styles.title}
        name="title"
        component={RenderInput}
        placeholder={i18n.t('notifications.title')}
        type="text"
      />
      <Field
        name="body"
        component={RenderTextarea}
        placeholder={i18n.t('notifications.writeMessage')}
        type="text"
      />
    </PopupContent>
    <PopupFooter isBorderless>
      <div className={styles.footerWrapper}>
        <div className={styles.sendOnlyToInRoute}>
          <label className={styles.footerMessage}>{/* eslint-disable-line */}
            {i18n.t('notifications.onlyRoute')}
            <Field
              name="only_in_route"
              component={RenderToggleSwitch}
              trueTitle={Boolean(true)}
              falseTitle={Boolean(false)}
              size="small"
              position="right"
              value
            />
          </label>
        </div>
        <div className={styles.actions}>
          <PopupCloseButton size="medium" title={Cancel()} tint="paleGray" />
          <Button type="submit" size="medium" title={i18n.t('buttons.send')} isLoading={isLoading} />
        </div>
      </div>
    </PopupFooter>
  </form>
);

const NotificationPopover = connect(
  state => ({
    school: (selectors.getProfileOfType(state, 'admin') || {}).school,
    isLoading: selectors.isSendingNotification(state),
  }),
  dispatch => ({
    changeScreen(screen) {
      dispatch(notificationsActions.changePopupScreen(screen));
    },
  }),
)(reduxForm({
  form: 'sendNotificationForm',
  onSubmit(
    {
      user_groups,
      only_in_route,
      title,
      body,
    },
    dispatch,
  ) {
    dispatch(notificationsActions.sendNotificationStarted(
      title,
      body,
      user_groups.map(({ base_model_id, group_type, target_role }) => ({
        base_model_id,
        group_type,
        target_role,
        only_in_route: !!only_in_route,
      })),
    ));
  },
})(NotificationPopoverDummy));

export default NotificationPopover;



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationPopoverContent/index.jsx